export default __webpack_public_path__ + "static/illustration-content-title.url-df121098df495cf6fbc0f4337d4301cb.svg";